import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import WarningIcon from '@mui/icons-material/Warning';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';

import { useDigestDeleteModalStore } from './DigestDeleteStore';

import useDeleteDigestReport from 'hooks/DigestReports/useDeleteDigestReport';

const DigestDeleteModal = () => {
  const { isOpen, closeDeleteDigestModal, slug, refetchPeriodReports, id } = useDigestDeleteModalStore();
  const { deleteDigestReport } = useDeleteDigestReport();
  const { t } = useTranslation();

  const onReset = () => {
    closeDeleteDigestModal();
  };

  const onDelete = () => {
    deleteDigestReport(
      { slug: slug || '', id: id || 0 },
      {
        onSuccess: () => {
          enqueueSnackbar('Digest report was deleted successfully', { variant: 'success' });
          refetchPeriodReports();
          closeDeleteDigestModal();
        },
      },
    );
  };

  return (
    <div>
      <Modal isOpen={isOpen} toggle={onReset} size="md">
        <ModalBody>
          <div className="mt-4 pt-4 d-flex flex-column  justify-content-center">
            <div className="d-flex align-items-center justify-content-center">
              <WarningIcon color="warning" fontSize="large" style={{ width: '100px', height: '100px' }} />
            </div>
            <h4 className="text-center">{`${t('DigestDeleteModal.title')} `}</h4>
            <p className="text-center my-2 text-muted">{t('DigestDeleteModal.description')}</p>
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button color="danger" onClick={onDelete}>
            {t('DigestDeleteModal.deleteButton')}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DigestDeleteModal;
